module.exports = __webpack_public_path__ + "prj_11.bb37a3aa.jpeg";